module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/perfil/perfil.component.css
// module id = ./src/app/components/perfil/perfil.component.css
// module chunks = main